import React, { useEffect } from "react";
import withAuthPersist from "stores/AuthenticationStore/withAuthPersist";
import "i18n/i18n";
import "stores/middlewares/logger";
import "stores/middlewares/persistent";
// import { PSChatProvider, PSBubbleBot } from "@communi/chat-react";
import { RouterProvider } from "react-router-dom";
import router from "pages/routes";
import { Provider, useSelector } from "react-redux";
import { store, RootState } from "stores";
import NotificationPopup from "./components/common/notification-popup/NotificationPopup";
import { useDefaultBank } from "hooks/useDefaultBank";

// Favicon lấy theo ngân hàng mặc định (logo Javis BIZ) từ API getDefaultBank.
// Dùng chung hook useDefaultBank để không sinh endpoint getDefaultBank trùng tên
// trong RTK Query — trùng tên thì bản inject sau bị bỏ qua (im lặng) và request
// sẽ đi sai url/categoryCode, khiến favicon rơi về logo tĩnh cũ.
const FaviconLoader: React.FC = () => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const { image, hasApiImage, refetch } = useDefaultBank();

  // getDefaultBank bị interceptor gắn sessionId. FaviconLoader nằm ở root nên query
  // chạy ngay lúc chưa đăng nhập → BE từ chối, mà endpoint có keepUnusedDataFor 24h
  // + refetchOnMountOrArgChange: false và component không bao giờ unmount, nên kết quả
  // lỗi đó không bao giờ được gọi lại → favicon mãi là logo tĩnh cũ.
  // Vì vậy phải refetch khi đã có session.
  // Điều kiện phải là `!hasApiImage` (chưa có logo THẬT từ API), không phải `!image` —
  // vì `image` giờ luôn có giá trị nhờ fallback logo Javis BIZ nên `!image` sẽ không bao giờ đúng.
  useEffect(() => {
    if (isAuthenticated && !hasApiImage) refetch();
  }, [isAuthenticated, hasApiImage, refetch]);

  useEffect(() => {
    if (!image) return;
    const link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (link) link.href = image;
  }, [image]);
  return null;
};

export const App: React.FC = () => {
  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div",
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay",
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  return (
    <>
      <Provider store={store}>
        <FaviconLoader />
        <RouterProvider router={router} />
        <NotificationPopup />
      </Provider>
      {/* <PSChatProvider
        appId="2e0abcpf5ff"
        fetchToken={async () => {
          // lấy token ở đây, ví dụ:
          return "your-auth-token";
        }}
      >
        <PSBubbleBot botId="your-bot-id" />
      </PSChatProvider> */}
    </>
  );
};

export default withAuthPersist(App);
